import React, { Component } from 'react';
import axios from 'axios';
import { isEmpty } from "lodash";

import { Box, Typography, TableContainer, Table, TableBody, TableRow, TableCell, IconButton, TableHead, Button } from '@mui/material';
import { HistoryRounded, ListRounded, More, MoreHorizOutlined, MoreHorizRounded } from '@mui/icons-material';
import Basic from '../../container/layouts/Basic';
import CreditsListUser from './Credits/CreditsListUser';
import { orderByAsc, orderByDsc } from '../../store/actions/format';
import UserUpdatePassword from '../Admin/Users/UserUpdatePassword';
import Notif from '../common/Notif';
import Currency from '../common/Currency';
import Dialog from '../common/Dialog';

class Profile extends Component {
    state = { 
        history: [],
        payments: [],
        openHistory: false,
        notif: {
            openNotif: false,
            variant:"",
            message: "",
        },
    }
    getUserHistory = async () => {
        const res = await axios.get("/users/credit/history") 
        if (res.data) {
            if (res.data.error) {
                console.log('==== getUserHistory ================');
                console.log(res.data.error);
                console.log('====================================');
            } else {
                this.setState({
                    history: orderByDsc(res.data, "credit_date"),
                    openHistory: true,
                })
            }
        } else {
            console.log('==== getUserHistory ================');
            console.log("no Response");
            console.log('====================================');
        }

        this.getUserPayments()
    }
    getUserPayments = async () => {
        const res = await axios.get("/users/credit/payments") 
        if (res.data){
            if (res.data.error) {
                console.log('==== getUserHistory ================');
                console.log(res.data.error);
                console.log('====================================');
            } else {
                this.setState({
                    payments: orderByDsc(res.data, "payment_date"),
                })
            }
        } else {
            console.log('==== getUserHistory ================');
            console.log("no Response");
            console.log('====================================');
        }
    }
    handleHistory = (open = true) => {
        this.setState({
            openHistory: open,
        })
    }
    handleUpdatePassword = () => {
        this.setState({
            updatePwd: true
        })
    }
    notif = (variant, message) => {
        console.log('==================NOTIF==================');
        console.log(variant, message);
        console.log('====================================');
        this.setState({
            notif:{
                openNotif: true,
                variant,
                message
            }
        })
    }
    handleCloseNotif = () => {
        this.setState({ 
            notif: {
                openNotif: false,
                variant:"",
                message: "",
            }
        });
    };
    render() {
        const { history, openHistory, payments, updatePwd } = this.state;
        const { variant, message, openNotif } = this.state.notif;

        return (
            <Basic page="Profile" {...this.props}>
                {openNotif && variant && message &&
                    <Notif open={true} {...this.state.notif} onClose={this.handleCloseNotif} />
                }
                {openHistory &&
                    <Dialog
                        open={true}
                        close={() => this.handleHistory(false)}
                        title="Historique"
                        maxWidth="md"
                        fullWidth
                    >
                        <CreditsListUser
                            USER_CREDITS={history}
                            USER_PAYMENTS={payments}
                            handleCloseAll={() => this.handleHistory(false)}
                            {...this.props}
                        />
                    </Dialog>
                }
                {updatePwd &&
                    <UserUpdatePassword
                        open={true}
                        handleClose={() => this.setState({ updatePwd: false }) }
                        notif={this.notif}
                        {...this.props}
                    />
                }
                <Typography variant="h6">Profil</Typography>
                <TableContainer>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell component="th">Nom</TableCell>
                                <TableCell>{this.props.user && this.props.user.lastname}</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th">Prénom</TableCell>
                                <TableCell>{this.props.user && this.props.user.username}</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th">Email</TableCell>
                                <TableCell>{this.props.user && this.props.user.email}</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th">Avoir Disponible</TableCell>
                                <TableCell><Currency value={this.props.user && this.props.user.account} /></TableCell>
                                <TableCell onClick={isEmpty(history) ? this.getUserHistory : this.handleHistory}>
                                    <IconButton color="primary">
                                        {/* <MoreHorizRounded/> */}
                                        <ListRounded />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={3} >
                                    <Button onClick={this.handleUpdatePassword} color="secondary" variant="contained" >Modifier le mot de passe</Button>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                
            </Basic>
        );
    }
}

export default Profile;